<template>
  <div>
    <Card style="line-height: 2">
      <div class="detail-header">
        <h2>{{$t('pages_orders_show_644')}}</h2>
        <div>
          <Button v-if="(this.order.status === 'paid' || this.order.status === 'waiting_confirmed') && (this.order.come_from === 'wechat_mini' || this.order.come_from === 'h5')"
                  type="info"
                  @click="showDeliverModal">{{$t('pages_orders_show_645')}}</Button>
          <Button style="margin-left: 12px"
                  type="default"
                  v-if="this.order.status === 'waiting_confirmed' && (this.order.come_from === 'wechat_mini' || this.order.come_from === 'h5')"
                  @click="confirmRefund">{{$t('pages_orders_show_646')}}</Button>
          <el-button
                  style="margin-left: 12px"
                  type="primary"
                  size="medium"
                  @click="handleShowRepair"
                >{{$t('pages_orders_show_647')}}</el-button>
          <el-button
                  type="primary"
                  size="medium"
                  @click="exportData"
                  icon="el-icon-download"
                >{{$t('pages_customers_index_311')}}</el-button>
        </div>
      </div>
      <div class="detail-item-wrap">
        <p class="detail-item" v-for="(value,key) in detailMap" :key="key">
          <template v-if="order && order[key] !== null">
            <span>{{detailMap[key]}}</span>: <span>{{order[key]}}</span>
          </template>
        </p>
        <p class="detail-item">
          <span>下单平台: {{this.order.come_from ==='wechat_mini' ? $t('libs_table_render_52') : (this.order.come_from === 'h5' ? 'H5' : (this.order.come_from === 'scan_desk' ? $t('libs_table_render_53') : $t('libs_table_render_51')))}}</span>
        </p>
        <p class="detail-item" v-if="this.order.delivery">
          <span>订单类型: {{orderTypeChinese('', this.order.delivery)}}</span>
        </p>
        <!-- 餐饮行业 -->
        <template v-if="shopType === 'chinese'">
          <p class="detail-item">
            <span>{{$t('pages_orders_show_650', [this.order.fresh_desk_name])}}</span>
          </p>
          <p class="detail-item">
            <span>{{$t('pages_orders_show_651', [this.order.finish_total])}}</span>
          </p>
        </template>
        <template v-if="this.order.delivery === 'takeout' && this.order.syoo_order">
          <p class="detail-item">
            <span>{{$t('pages_orders_show_652', [this.order.syoo_order.distribution_channel_text])}}</span>
          </p>
          <p class="detail-item">
            <span>{{$t('pages_orders_show_653', [this.order.syoo_order.distribution_status_text])}}</span>
            <el-button
              type="primary"
              size="small"
              @click="handleCallDelivery">{{$t('pages_orders_show_654')}}</el-button>
          </p>
        </template>
        <p>
          <span v-if="order.express_no" class>{{$t('pages_orders_show_655')}}<a href="https://www.kuaidi100.com/?from=openv" target="_blank">{{ order.express_no }}</a></span>
        </p>
        <div v-if="order.fresh_address">
          <span>{{$t('pages_orders_show_656', [ order.fresh_address.province , order.fresh_address.city_name , order.fresh_address.district , order.fresh_address.content , order.fresh_address.username , order.fresh_address.mobile ])}}</span>
        </div>
        <div>
          <span class>{{$t('pages_orders_show_657')}}<Tag :color="this.paymentChinese(this.order.status).color">
              {{this.paymentChinese(this.order.status).text}}
            </Tag>
            <span style="color: orangered;margin-left: 15px"
                  v-if="order.status === 'waiting_confirmed' || order.status === 'refunded'">{{$t('pages_orders_show_658', [ order.refund_reason ])}}{{ order.refund_express_no ? '退货退款' : $t('pages_orders_show_659') }}
            </span>
          </span>
        </div>
        <div v-if="order.refund_express_no">{{$t('pages_orders_show_660', [ order.refund_express_no ])}}</div>
        <!-- <template v-if="order.promote_company_staff_id">
          <p class="detail-item">
            <span>分佣金额: {{order.rebate_price}}</span>
            <el-button
              type="primary"
              size="small"
              @click="showRebatePrice">修改金额</el-button>
          </p>
          <p class="detail-item">
            <span>是否已分佣: </span>
            <i-switch v-model="order.is_finish_rebate" @on-change="updateOrder">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </p>
        </template> -->
      </div>
      <br />
      <!-- <br /> -->
      <span>{{$t('pages_orders_show_661')}}</span>
      <i-table style="margin-top: 20px;width: 100%"
             ref="orderDetail"
             border
             :loading="loading"
             :columns="columns"
             :data="order.fresh_order_items"></i-table>
      <Modal :title="$t('pages_orders_show_662')"
             v-model="showDeliver"
             @on-ok="deliver">
        <Form>
          <Form-Item :label="$t('pages_orders_show_663')">
            <Input type="textarea"
                   v-model="express_no"
                   :placeholder="$t('pages_orders_show_664')" />
          </Form-Item>
        </Form>
      </Modal>
      <Modal :title="$t('pages_orders_show_665')"
             v-model="showRefundOrder"
      >
        <Form>
          <Form-Item :label="$t('pages_balance_transaction_index_175')">
            <Input type="number"
                   v-model="refund_price"
                   :placeholder="$t('pages_orders_show_666')" />
          </Form-Item>
        </Form>
         <div slot="footer">
            <Button @click="cancelRefundOrder">{{$t('pages_city_shop_freights_index_250')}}</Button>
            <Button type="primary" :loading="refundOrderLoading" @click="hundle_refund_order">{{$t('pages_city_shop_freights_index_251')}}</Button>
        </div>
      </Modal>
      <Modal :title="$t('pages_orders_show_647')"
             :width="650"
             :loading="formLoading"
             v-model="showRepair"
              @on-ok="handleRepair"
      >
        <Form ref="repair_price" :model="repairInfo" :rules="repairRules" :label-width="100">
          <Form-Item :label="$t('pages_orders_show_667')" prop="repair_price">
            <Input type="number"
                   v-model="repairInfo.repair_price"
                   :placeholder="$t('pages_orders_show_666')" />
          </Form-Item>
          <Form-Item :label="$t('pages_orders_show_668')" prop="finish_total">
            <Input type="number"
                   v-model="repairInfo.finish_total"
                   :placeholder="$t('pages_orders_show_669')" />
          </Form-Item>
          <Form-Item :label="$t('pages_orders_show_670')">
            <el-table
              :data="repairInfo.fresh_order_items"
              style="width: 100%"
              height="250"
              >
              <el-table-column
                prop="current_product_name"
                :label="$t('pages_bookings_detail_222')"
              >
              </el-table-column>
              <el-table-column
                prop="current_price"
                :label="$t('pages_bookings_detail_224')"
              >
               <template slot-scope="scope">
                 <el-input v-model="scope.row.current_price"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="quantity"
                :label="$t('pages_bookings_detail_223')">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.quantity"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="total"
                :label="$t('pages_orders_show_671')">
                <template slot-scope="scope">
                 {{scope.row.quantity * scope.row.current_price}}
                </template>
              </el-table-column>
            </el-table>
          </Form-Item>
          <Form-Item :label="$t('pages_bookings_index_230')" prop="merchant_remark">
            <Input type="textarea"
                   v-model="repairInfo.merchant_remark"
                   :placeholder="$t('pages_bookings_index_230')" />
          </Form-Item>
        </Form>
      </Modal>
      <Modal :title="$t('pages_orders_show_672')"
             :width="650"
             v-model="showPartRefund"
              @on-ok="handlePartRefund"
      >
        <Form :model="partRefundInfo" :label-width="100">
          <Form-Item :label="$t('pages_orders_show_673')">
            <el-select v-model="partRefundInfo.payment_method" :placeholder="$t('pages_orders_show_674')">
              <el-option
                v-for="item in payment_methods"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </Form-Item>
          <Form-Item :label="$t('pages_orders_show_670')">
            <el-table
              :data="partRefundInfo.refund_order_items"
              style="width: 100%"
              height="250"
              >
              <el-table-column
                prop="current_product_name"
                :label="$t('pages_bookings_detail_222')"
              >
              </el-table-column>
              <el-table-column
                prop="mall_sku_name"
                label="sku"
              >
              </el-table-column>
              <el-table-column
                prop="origin_quantity"
                :label="$t('pages_orders_show_675')"
              >
              </el-table-column>
              <el-table-column
                prop="quantity"
                :label="$t('pages_orders_show_676')">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.quantity"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </Form-Item>
        </Form>
      </Modal>
      <!-- <Modal title="修改金额"
             v-model="showRebatePriceModal"
             @on-ok="handleRebatePrice">
        <Form>
          <Form-Item label="分佣金额">
            <el-input v-model="rebate_price"
                      placeholder="请填写分佣金额" />
          </Form-Item>
        </Form>
      </Modal> -->
    </Card>
    <!-- 导出的excel -->
    <table ref="exportTable" style="display: none;">
      <thead>
        <tr>
          <th v-for="item in exportFields"
              :key="item.key" :style="{width: item.width}">{{ item.title }}</th>
        </tr>
      </thead>
      <tr v-for="row in order.fresh_order_items" :key="row.id">
        <td v-for="field in exportFields" :key="field.id">{{ getExportColumnData(row, field) }}</td>
      </tr>
      <tr>
        <td>{{$t('pages_bookings_detail_225')}}</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>{{order.finish_total}}</td>
      </tr>
      <tr>
        <td>{{$t('pages_orders_show_677')}}</td>
        <td>{{order.freight}}</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>{{$t('pages_orders_show_678')}}</td>
        <td>{{order.package_price}}</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>{{$t('pages_balance_transaction_index_177')}}</td>
        <td>{{order.created_at_str}}</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    </table>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import { booleanChinese, paymentChinese, commonButtonInTable, orderTypeChinese } from '@/libs/table-render'
import _ from 'lodash';
const detailMap = {
  code: i18n.t('pages_bills_index_197'),
  payment_method_str: i18n.t('pages_customers_index_319'),
  discount: i18n.t('pages_orders_show_679'),
  birthday_discount: i18n.t('pages_birthday_discount_index_205'),
  small_discount: i18n.t('pages_customers_orders_353'),
  created_at_str: i18n.t('pages_balance_transaction_index_177'),
  refund_reason: i18n.t('pages_orders_show_680'),
  cancel_reason: i18n.t('pages_orders_show_681'),
  refund_express_no: i18n.t('pages_orders_show_682'),
  shop_name: i18n.t('pages_lcsw_accounts_index_553'),
  fresh_customer_mobile: i18n.t('pages_orders_show_683'),
  description: i18n.t('pages_balance_transaction_index_174'),
  change_amount: i18n.t('pages_orders_show_684'),
  custom_percentage_discount: i18n.t('pages_orders_show_685'),
  customer_discounted_total: i18n.t('pages_orders_show_686'),
  suzhou_zyz_discount_amount: '志愿者积分抵扣',
  discounted_total: i18n.t('pages_orders_show_687'),
  combo_discount: i18n.t('pages_orders_show_688'),
  first_order_discount: i18n.t('pages_orders_show_689'),
  limit_time_discount: i18n.t('pages_limited_time_activity_index_590'),
  enough_consume_discount: i18n.t('pages_orders_show_690'),
  finish_total: i18n.t('pages_dashboards_statement_product_components_summary_362'),
  payment_total: i18n.t('pages_orders_show_691'),
  small_discounted_amount: i18n.t('pages_orders_show_692'),
  total: i18n.t('pages_orders_show_693'),
  offline_coupon: i18n.t('pages_orders_show_694'),
  second_card_amount: i18n.t('pages_bills_index_204'),
  freight: i18n.t('pages_orders_show_677'),
  package_price: i18n.t('pages_orders_show_678'),
}
const exportFields = [
  {
    title: 'ID',
    key: 'id',
  },
  {
    title: i18n.t('pages_bookings_detail_222'),
    key: 'current_product_name',
    width: '120px'
  },
  {
    title: i18n.t('pages_orders_index_634'),
    key: 'fresh_product_bar_code',
    width: '120px'
  },
  {
    title: i18n.t('pages_orders_index_635'),
    key: 'fresh_product_specs',
    width: '140px'
  },
  {
    title: i18n.t('pages_orders_show_695'),
    key: 'preferences',
    width: '140px'
  },
  {
    title: i18n.t('pages_bookings_detail_224'),
    key: 'current_price',
    width: '50px'
  },
  {
    title: i18n.t('pages_orders_index_637'),
    key: 'quantity',
    width: '80px'
  },
  {
    title: i18n.t('pages_dashboards_statement_product_index_375'),
    key: 'total',
    width: '80px'

  },
  {
    title: i18n.t('pages_booking_store_products_index_221'),
    key: 'fresh_product_unit',
    width: '80px'

  },
  {
    title: i18n.t('pages_bills_index_197'),
    key: 'code',
    width: '140px'

  },
  {
    title: i18n.t('pages_orders_index_632'),
    key: 'shop_name',
    width: '100px'

  },
  {
    title: i18n.t('pages_customers_index_313'),
    key: 'fresh_customer_username',
    width: '100px'

  },
  {
    title: i18n.t('pages_orders_show_696'),
    key: 'fresh_address',
    width: '140px'

  },
  {
    title: i18n.t('pages_orders_show_697'),
    key: 'fresh_customer_mobile',
    width: '100px'

  },
];

export default {
  data () {
    return {
      id: this.$route.params.id,
      refund_price: '',
      showRefundOrder: false,
      refundOrderLoading: false,
      detailMap,
      columns: [
        {
          title: 'ID',
          key: 'id',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_orders_index_635'),
          key: 'fresh_product_specs',
          width: 200,
          align: 'center'
        },
        {
          title: i18n.t('pages_bookings_detail_222'),
          key: 'current_product_name',
          width: 200,
          align: 'center',
          render: (h, params) => {
            return (
              <div>
                { params.row.current_product_name}
              </div>
            );
          }
        },
        {
          title: i18n.t('pages_orders_show_698'),
          key: 'mall_sku_name',
          width: 200,
          align: 'center'
        },
        {
          title: i18n.t('pages_orders_show_699'),
          key: 'fresh_material_fresh_order_items',
          width: 200,
          align: 'center',
          render: (h, params) => {
            const children = []
            params.row.fresh_material_fresh_order_items.forEach(item=> children.push(h('div', `${item.fresh_material_name}(${item.fresh_material_price})`)))
            return h('div', children);
          }
        },
        {
          title: i18n.t('pages_orders_show_700'),
          key: 'preferences',
          width: 200,
          align: 'center'
        },
        {
          title: i18n.t('pages_bookings_detail_224'),
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('div', params.row.current_price);
          }
        },
        {
          title: i18n.t('pages_bookings_detail_223'),
          key: 'quantity',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_orders_show_671'),
          key: 'total',
          width: 100,
          align: 'center',
          render: (h, params) => {
            const {total, fresh_material_fresh_order_items} = params.row
            let totalPrice = total*1
            fresh_material_fresh_order_items.forEach(item=> totalPrice += item.fresh_material_price*1)
            return h('div', totalPrice);
          }
        },
        {
          title: i18n.t('pages_booking_store_products_index_221'),
          key: 'fresh_product_unit',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_ai_thirdparty_168'),
          width: 100,
          align: 'center',
          render: (h, params) => {
            return booleanChinese(h, params.row.product_need_to_weight)
          }
        },
        {
          title: i18n.t('pages_ai_image_163'),
          width: 200,
          align: 'center',
          render: (h, params) => {
            const children = []
            children.push(
              commonButtonInTable(
                this,
                h,
                'info',
                i18n.t('pages_orders_show_672'),
                this.handleShowPartRefund,
                [params.row]
              )
            )
            return h('div', children)
          }
        }
      ],
      showDeliver: false,
      express_no: '',
      expressLoading: false,
      exportFields,
      address: '',
      shop_name: '',
      showRepair: false,
      payment_methods: [{
        name: i18n.t('libs_table_render_74'),
        value: 'cash_pay'
      },
      {
        name: i18n.t('libs_table_render_75'),
        value: 'svc_pay'
      }],
      showPartRefund: false,
      orderTypeChinese,
      repairRules: {
        repair_price: [{ required: true, message: i18n.t('pages_orders_show_666') }],
        finish_total: [{ required: true, message: i18n.t('pages_orders_show_701') }],
        merchant_remark: [{ required: true, message: i18n.t('pages_orders_show_702') }],
      },
      formLoading: true,
      shopType: localStorage.getItem('SHOP_TYPE'),
      // showRebatePriceModal: false,
      // rebate_price: 0
    }
  },
  async created () {
    await this.show(this.id);
  },
  computed: {
    ...mapGetters('order', ['order', 'meta', 'loading']),
    ...mapState('order', ['repairInfo', 'partRefundInfo']),
  },
  methods: {
    ...mapActions('order', ['show', 'update', 'deliver_order', 'refund_order', 'merchant_repair', 'part_refund', 'call_delivery']),
    ...mapMutations('order', ['changeQuery', 'resetQuery']),
    handleCallDelivery () {
      this.call_delivery(this.id)
    },
    handleShowPartRefund (data) {
      const p = {
        fresh_product_id: data.fresh_product_id,
        origin_quantity: data.quantity,
        quantity: data.quantity,
        mall_sku_id: data.mall_sku_id,
        current_price: data.current_price,
        current_product_name: data.current_product_name,
        mall_sku_name: data.mall_sku_name,
      }
      this.partRefundInfo.refund_order_items = [p]
      this.showPartRefund = true
    },
    handlePartRefund () {
      this.part_refund(this.id);
      this.show(this.id)
    },
    handleRepair () {
      this.$refs.repair_price.validate(async valid => {
        if (valid) {
          let productInfo = true
          const { fresh_order_items } = this.repairInfo
          let i = 0
          const { length } = fresh_order_items
          for (i; i < length; i++) {
            const { current_price, quantity } = fresh_order_items[i]
            if (!current_price || !quantity) {
              productInfo = false
              break
            }
          }
          if (!productInfo) {
            this.formLoading = false
            this.$nextTick(() => {
              this.formLoading = true
            })
            return this.$message.warning(i18n.t('pages_orders_show_703'));
          }
          await this.merchant_repair(this.id)
          this.show(this.id)
          this.showRepair = false
        } else {
          this.formLoading = false
          this.$nextTick(() => {
            this.formLoading = true
          })
        }
      });
    },
    handleShowRepair () {
      this.repairInfo.fresh_order_items = this.order.fresh_order_items;
      this.showRepair = true
    },
    getExportColumnData (row, config) {
      if (config.key === 'code') {
        return '   ' + this.order.code
      } else if (config.key === 'fresh_address') {
        if (this.order.fresh_address) {
          return this.order.fresh_address.province + this.order.fresh_address.city + this.order.fresh_address.district + this.order.fresh_address.content + this.order.fresh_address.username + this.order.fresh_address.mobile
        }
        return ''
      } else if (config.key === 'fresh_customer_mobile') {
        return this.order.fresh_customer_mobile
      } else if (config.key === 'shop_name') {
        return this.order.shop_name
      } else if (config.key === 'fresh_customer_username') {
        return this.order.fresh_customer_username
      }
      let val = _.get(row, config.key);
      if (/\d/.test(val)) {
        val = '   ' + val
      }
      return config.render ? config.render(val) : val
    },
    async exportData () {
      const book = XLSX.utils.book_new();
      const s1 = XLSX.utils.table_to_sheet(this.$refs.exportTable);
      XLSX.utils.book_append_sheet(book, s1, i18n.t('pages_orders_show_704'));
      const base64 = XLSX.write(book, { bookType: 'xlsx', type: 'base64' });
      const a = document.createElement('a');
      a.setAttribute('download', i18n.t('pages_orders_show_704'));
      a.href = 'data:application/vnd.ms-excel;base64,' + base64;
      a.click();
    },
    current_price (lingshoujia, huiyuanjia) {
      return this.order.fresh_customer_id === null ? lingshoujia : huiyuanjia
    },
    paymentChinese (method) {
      const h = (tagName, conf, text) => {
        return {
          color: conf && conf.props && conf.props.color,
          text,
        }
      };
      return paymentChinese(h, method);
    },
    showDeliverModal () {
      this.express_no = '';
      this.showDeliver = true;
    },
    deliver () {
      const self = this;
      this.$nextTick(() => {
        const ask = () => {
          return new Promise((resolve, reject) => {
            if (!this.express_no) {
              this.$Modal.confirm({
                title: i18n.t('pages_orders_show_705'),
                content: i18n.t('pages_orders_show_706'),
                onOk: () => {
                  resolve();
                },
                onCancel: () => {
                  console.warn(i18n.t('pages_orders_show_707'));
                }
              });
            } else {
              resolve();
            }
          });
        }
        ask().then(() => {
          setTimeout(() => {
            this.$Modal.confirm({
              title: i18n.t('pages_orders_show_705'),
              content: i18n.t('pages_orders_show_708'),
              onOk: () => {
                this.deliver_order({ id: self.id, express_no: self.express_no })
              }
            })
          }, 400)
        });
      });
    },
    cancelRefundOrder () {
      this.refund_price = ''
      this.showRefundOrder = false
      this.refundOrderLoading = false
    },
    async hundle_refund_order () {
      if (!this.refund_price) {
        this.$message.warning(i18n.t('pages_orders_show_709'));
        return;
      }
      this.refundOrderLoading = true
      this.refund_order({
        refund_price: this.refund_price,
        id: this.id
      }).then(() => {
        this.showRefundOrder = false
      }).catch(() => {
        this.refundOrderLoading = false
      })
    },
    confirmRefund () {
      this.showRefundOrder = true
    },
    // showRebatePrice () {
    //   this.rebate_price = this.order.rebate_price
    //   this.showRebatePriceModal = true;
    // },
    // handleRebatePrice () {
    //   // console.info(this.rebate_price)
    //   this.order.rebate_price = this.rebate_price
    //   this.updateOrder()
    // },
    updateOrder () {
      this.order.order_items = this.order.fresh_order_items
      this.order.order_items.map(item => (item.product_id = item.fresh_product_id))
      this.update(this.order)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="less">
.filter-container {
  padding-bottom: 10px;
  .filter-item {
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 10px;
  }
}
.detail-header{
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.detail-item-wrap{
  .detail-item{
    float: left;
    width: 33.3%;
    .el-button {
      margin-left: 5px;
    }
  }
}
</style>
